import {NavbarMenu} from './components/NavbarMenu';
import YouTubePlayer from '../../../node_modules/youtube-player';

$(document).ready(function () {
  if (gaOptOptions.gaAppId) {
    var gaOptOut = new ApGaOptOut({
      gaAppId: gaOptOptions.gaAppId,
      optOutCallEvent: 'click',
      elementSelector: '.js-analytics-optout',
      debug: false,
      showAlterAfterDeactivate: true
    });
  }
});
//Youtube Player
// $(function () {
//   $('.dropdown ul li').hover(function (ev) {
//     let $this = $(this);
//     let $dropDown = $this.parent().parent();
//     $dropDown.toggleClass('active-hover');
//   });
//   // const $header = $('#header');
//   // new NavbarMenu($header);
//   $('.test-now-checkbox').click(function (ev) {
//     let $this = $(this);
//     $('.test-now-checkbox').prop('checked', false);
//     $('.test-now-checkbox').removeAttr('required');
//     $this.attr('required', true);
//     $this.prop('checked', true);
//   });
//   var players = [];
//   var youtubeIds = [];
//   $('.youtube_video_ga').each(function (index, value) {
//     let $this = $(this);
//     let $youtubeVideoId = $this.attr('id');
//     youtubeIds.push($this.attr('play-button'));
//     players[index] = new YouTubePlayer($youtubeVideoId);
//   });
//   for (let index in youtubeIds) {
//     let $currentVideoPlayButton = $('.video-play-' + youtubeIds[index]);
//     let $videoPlayButtons = $('.yt-video-banner');
//     $currentVideoPlayButton.on("click", function (ev) {
//       let $this = $(this);
//       for (let playerIndex in players) {
//         players[playerIndex].pauseVideo().then(function () {
//           if ($this.hasClass('video-loaded')) {
//             $videoPlayButtons.removeClass('video-started');
//             $videoPlayButtons.removeClass('video-paused');
//           }
//         });
//       }
//       if (!$this.hasClass('video-loaded')) {
//         players[index].loadVideoById(youtubeIds[index]).then(function () {
//           $this.addClass('video-loaded');
//           $videoPlayButtons.addClass('video-paused');
//           $videoPlayButtons.removeClass('video-started');
//           $this.addClass('video-started');
//           $this.removeClass('video-paused');
//         });
//       } else {
//         players[index].playVideo().then(function () {
//           $videoPlayButtons.removeClass('video-started');
//           $videoPlayButtons.addClass('video-paused');
//           $this.addClass('video-started');
//           $this.removeClass('video-paused');
//         });
//       }
//     })
//   }
//
//   $(document).on("keyup", '.digits input[type=text]', function () {
//     let $this = $(this);
//     let serialNumber = getSerrialNumber($this.val());
//     $('input[name*=serialnnummer]').val(serialNumber);
//     return false;
//
//   });
//
//
//   function getSerrialNumber(value) {
//     let serrial = '';
//     $('.digits input[type=text]').each(function () {
//       let $this = $(this);
//       serrial += $this.val();
//     });
//     return serrial;
//   }
//
// });


$(document).ready(function () {
  $('body').addClass('page-loaded');
  $('#main-page-loader').fadeOut(0.1, function () {
    $('body').addClass('page-loaded');
  });

  $("button[name=warranty-button]").on("click", function () {

    if ($('select[name="geraet"]').length && $('select[name="geraet"]').val() === "0") {
      return false;
    }
  });


  $.fn.startLoading = function () {
    var loader = '<div class="loader-el">' +
        '<div class="loader-wrapper">' +
        '<div class="loader">' +
        '<svg class="circular" viewBox="25 25 50 50">' +
        '<circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"/>' +
        '</svg>' +
        '</div>' +
        '</div>' +
        '</div>';
    this.append(loader);
  };

  $.fn.stopLoading = function () {
    $('.loader-el').remove();
  };

  (function () {

    let clicked = false;
    //on submit forms show preloader
    $("button[name=contact-button],button[name=newsletter-button],button[name=just-test-button],button[name=warranty-button]").on("click", function (ev) {

      console.log("clicked ", clicked);
      if (clicked) {
        ev.preventDefault();
      } else {
        clicked = true;
      }
      setTimeout(function () {
        clicked = false
      }, 1000);
    });
  })();

  $("form").on("beforeSubmit", function () {
    $('body').startLoading();
  });

  $(document).on('pjax:complete', function () {
    $('body').stopLoading();
    $('#form-notify-modal').modal('show');
  });


  $(document).on('pjax:success', function () {
    if (typeof gtag === 'function') {
      gtag('config', gaOptOptions.gaAppId, {'page_path': '/danke'});
    }
    $('#form-notify-modal').addClass('message-success');
    return false;
  });

  $(document).on('pjax:error', function () {
    $('#form-notify-modal').addClass('message-error');
    return false;
  });

  $('#form-notify-modal').on('hidden.bs.modal', function () {
    window.location.reload();
  });

  //old way it was getting all of the tags, had to restrict since it was messing with cookie consent
  $('.main-wrapper h1, .main-wrapper h2, .main-wrapper h3, .main-wrapper p, .main-wrapper a, .main-wrapper div').html(function (i, old) {
    return old
        .replace(/®/gi, '<sup>&reg;</sup>');
  });
  $(document).on("keyup", '.digits input[type=text]', function () {
    let $this = $(this);
    let serialNumber = getSerrialNumber($this.val());
    $('input[name*=serialnnummer]').val(serialNumber);
    return false;

  });


  function getSerrialNumber(value) {
    let serrial = '';
    $('.digits input[type=text]').each(function () {
      let $this = $(this);
      serrial += $this.val();
    });
    return serrial;
  }
});

$(document).ready(function () {
  var $tables = $('.xmlblock table');
  $tables.each(function (ind, table) {
    var $table = $(table);
    var $wrapper = $('<div class="table-responsive">');
    $wrapper.insertBefore($table);
    $wrapper.append($table);
  });
});
